// Module Import
//---------------------------------
import React from 'react'
import styled from 'styled-components'
import AccordionRelatedProducts from '../AccordionRelatedProducts/AccordionRelatedProducts'

// Component Import
//---------------------------------

const AccessoriesWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`

// Styled Component Declarations
//---------------------------------

// Component Export
//---------------------------------
export default function RelatedProducts({
  onAction,
  onEnquireNowOpen,
  relatedProducts,
  isLoading,
}) {
  const assists =
    relatedProducts.filter(
      (assist) =>
        assist &&
        ([
          'heliguy-essential-support',
          'heliguy-advanced-support',
          'dji-terra-licence-for-m4t',
          'dji-terra-licence-for-m4e',
        ].includes(assist.handle) ||
          assist?.tags?.some((tag) => ['Repair Refresh', 'Gatsby-Repair-Refresh'].includes(tag)))
    ) || []
  const payloads =
    relatedProducts.filter(
      (payload) =>
        payload &&
        payload?.tags?.some((tag) => tag === 'Payloads') &&
        payload?.tags?.every((tag) => !['enquire only'].includes(tag.toLowerCase()))
    ) || []
  const accessories =
    relatedProducts.filter(
      (accessory) =>
        accessory &&
        accessory?.tags?.some((tag) => tag === 'Accessory') &&
        accessory?.tags?.every((tag) => !['enquire only'].includes(tag.toLowerCase()))
    ) || []
  const trainings =
    relatedProducts.filter(
      (training) =>
        training &&
        training?.tags?.some((tag) => tag === 'Training') &&
        (training.handle === 'dji-zenmuse-l1-workflow-course' ||
          training?.tags?.every((tag) => !['enquire only'].includes(tag.toLowerCase())))
    ) || []
  const boltOnPackages =
    relatedProducts.filter(
      (packageItem) =>
        packageItem &&
        packageItem?.tags?.some((tag) => tag === 'Bolt-on Packages') &&
        packageItem?.tags?.every((tag) => !['enquire only'].includes(tag.toLowerCase()))
    ) || []

  return (
    <AccessoriesWrapper>
      {/* ADD ASSIST AND PREMIUM PRODUCTS */}
      {assists.length !== 0 && (
        <AccordionRelatedProducts
          header="Heliguy Support Services"
          products={assists}
          isLoading={isLoading}
          onAction={onAction}
          onEnquireNowOpen={onEnquireNowOpen}
          isOpenOnMount
        />
      )}
      {payloads.length !== 0 && (
        <AccordionRelatedProducts
          header="Choose A Payload"
          products={payloads}
          isLoading={isLoading}
          onAction={onAction}
        />
      )}

      {accessories.length !== 0 && (
        <AccordionRelatedProducts
          header="Optional Extra Accessories"
          products={accessories}
          isLoading={isLoading}
          onAction={onAction}
        />
      )}

      {trainings.length !== 0 && (
        <AccordionRelatedProducts
          header="Choose A Training Course"
          products={trainings}
          isLoading={isLoading}
          onAction={onAction}
        />
      )}
      {boltOnPackages.length !== 0 && (
        <AccordionRelatedProducts
          header="Bolt-on Packages"
          products={boltOnPackages}
          isLoading={isLoading}
          onAction={onAction}
        />
      )}
    </AccessoriesWrapper>
  )
}
